import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DASHBOARD_METER_GROUP } from '../../../../const';
import { sortByOrder } from '../../../../utils/helpers';
import { useGroupsStore } from '../../store/groups';

export const useGroups = () => {
  const { t } = useTranslation('groups');
  const { groups: userGroups, groupsLoading } = useGroupsStore((s) => s);

  const groups = useMemo(
    () =>
      userGroups
        .map((userGroup) => ({
          ...userGroup,
          group: {
            ...userGroup.group,
            name: userGroup.group.isDefaultGroup ? t('favourites.header') : userGroup.group.name,
            iconName: userGroup.group.iconName,
          },
        }))
        .filter((userGroup) => userGroup.group.name !== DASHBOARD_METER_GROUP)
        .sort(sortByOrder),
    [userGroups, t],
  );

  const favouriteGroup = useMemo(() => userGroups.find((userGroup) => userGroup.group.isDefaultGroup), [userGroups]);

  return { groups, favouriteGroup, groupsLoading };
};
